import { CELL_WIDTH_REM, COMPACT_CELL_WIDTH_THRESHOLD_REM } from '../../constants';

/**
 * Calculates the cell width (in rem) from the current zoom level.
 * Horizontal zoom is the single control for grid density — the old minimize
 * boolean has been removed. Centralized to avoid duplication.
 *
 * @param zoomLevel - Current zoom level multiplier
 * @returns Calculated cell width in rem units
 */
export const calculateCellWidth = (zoomLevel: number): number => {
  return CELL_WIDTH_REM * zoomLevel;
};

/**
 * Whether the planner should use its compact display at the given cell width:
 * utilization dots instead of percentages, single-letter weekdays, tighter
 * assignment padding. Replaces the former `minimizeMode` boolean — compact mode
 * is now derived from cell width so it scales smoothly with zoom in both directions.
 *
 * @param cellWidth - Current cell width in rem (from calculateCellWidth)
 */
export const isCompactCellWidth = (cellWidth: number): boolean => {
  return cellWidth <= COMPACT_CELL_WIDTH_THRESHOLD_REM;
};
